// import { getInicisData } from "src/service/pay";

import { getProductFromSessionStorage } from "../storage/auth";

export const insertPaypalModule = async () => {
  const paypalScript = document.createElement("script");
  const prodName = getProductFromSessionStorage();
  const payPalScriptId = `${prodName}-paypalScript`;
  paypalScript.id = payPalScriptId;
  if (window.location.hostname === "cloudportal.fasoo.com") {
    if (window.sessionStorage.getItem("product") === "WRAPSODY_ECO") {
      paypalScript.src =
        "https://www.paypal.com/sdk/js?client-id=ATGN4I7CwCO44AN0bRSopvYd3l32mQsHdHbfYvWlBHYB7oNKk2RUrdHeaMmSiHneQ8U99IwY3IcvT-Xe&vault=true&intent=subscription";
    } else {
      paypalScript.src =
        "https://www.paypal.com/sdk/js?client-id=Adq4eobfggrPc-JG_W9VRXW1FR4xEr9zu812LzY1tpJ4V8ocL5s5R339Ifsi5gdXdYBZaBf4CLoqzhOB&vault=true";
    }
  } else {
    //테스트 계정일때
    if (window.sessionStorage.getItem("product") === "WRAPSODY_ECO") {
      paypalScript.src =
        "https://www.paypal.com/sdk/js?client-id=AeANYYv4hmgzO6d9WLqJiwJEmqm-M28fkxfHHsKPG5IC2Q5-AaWc03aACVyTuNNbl79xEB4IOVF3YlIW&vault=true&intent=subscription";
    } else {
      paypalScript.src =
        "https://www.paypal.com/sdk/js?client-id=AdjG8uJfAZ8zs8697nP-vBBF4UhP08uMq5ydDazRgwsp9vxBC1Jb_y8lyP8VharULLxGUwOFgoFPhHGP&vault=true";
    }
  }
  paypalScript.async = true;
  if (!document.getElementById(payPalScriptId)) {
    document.head.appendChild(paypalScript);
  }

  // let inicisData;

  // if (
  //   window.portal.customUserId === this.commonStore.userInfo.userInfo.userId
  // ) {
  //   inicisData = await getInicisData(
  //     window.portal.customUserPrice
  //   );
  // }
};
